module.exports = __webpack_public_path__ + "static/media/app_framed_tiny.f11826e2.png";